
import { Vue, Component, Prop } from "vue-property-decorator";



@Component({})
export default class FormDatepicker extends Vue {
  @Prop({ type: String, default: "" }) readonly class?: string;

  get classes(): object {
    return {
      [this.class]: true,
    };
  }

}
